import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * API элементов технических устройств, для которых создаются заключения
 */
@Injectable()
export class TechnicalDeviceElementApiService extends ApiService {
    baseUrl = 'technical-device-element';

    /**
     * Путь для редактирования и получения заключений элемента
     * @param elementId
     */
    getConclusionPath(elementId: number): string {
        return `${this.baseUrl}/${elementId}/conclusion`;
    }

    /**
     * Путь для создания нового пустого заключения
     * @param elementId
     */
    getConclusionBlankPath(elementId: number): string {
        return `${this.baseUrl}/${elementId}/conclusion-blank`;
    }

    /**
     * Путь до получения структуры динамических полей подписантов
     * @param elementId
     */
    getSignersStructurePath(elementId: number): string {
        return `${this.baseUrl}/${elementId}/signers-structure`;
    }
}
